export default __webpack_public_path__ + "static/media/winner.4645d5b2.webp";